import { render, staticRenderFns } from "./cfta.vue?vue&type=template&id=06ac118f&"
import script from "./cfta.vue?vue&type=script&lang=js&"
export * from "./cfta.vue?vue&type=script&lang=js&"
import style0 from "./cfta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports